export default "__VITE_ASSET__C5QIYsMa__"